export { RangeIcon } from './range'
